import React from 'react';

import useUserHook from 'hooks/useUserHook';

import { IComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { SharedResourcesAvailability } from 'components/widgets/SharedResourcesAvailability/sharedResourcesAvailability';

export const SharedResourcesAvailabilityWrapper = ({
    latestVersionId,
    projectId,
    contractId,
    globalFilterData,
}: IComponentProps) => {
    const { ability } = useUserHook();

    return ability.can('view', 'SharedResources') ? (
        <SharedResourcesAvailability
            latestVersionId={latestVersionId}
            projectId={projectId}
            contractId={contractId}
            globalFilterData={globalFilterData}
        />
    ) : null;
};
